export default __webpack_public_path__ + "static/media/ar-workbench-map.ea0c8e93.webp";